module.exports = __webpack_public_path__ + "img/cam-overlay-front.317cbf36.svg";